/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table6({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: 0,
        value10: "",
        value11: 0,
        value12: "",
        value13: 0,
        value14: 0,
        value15: 0,
        value16: 0,
        value17: 0,
        value18: 0,
        value19: 0,
        value20: 0,
        value21: 0,
        value22: "",
        value23: 0,
        value24: 0,
        value25: 0,
      },
    ],
    muc2: [
      {
        bg: true,
        id: uuidV4(),
        value2: "Thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế TNDN",
        value3: "[16]",
        value4: 0,
      },
      {
        bg: false,
        id: uuidV4(),
        value2: "Thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này",
        value3: "[17]",
        value4: 0,
      },
      {
        bg: false,
        id: uuidV4(),
        value2: "Thuế TNDN đã tạm nộp trong năm",
        value3: "[18]",
        value4: 0,
      },
      {
        bg: true,
        id: uuidV4(),
        value2: "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm",
        value3: "[19]",
        value4: 0,
      },
      {
        bg: true,
        id: uuidV4(),
        value2: "Thuế TNDN còn phải nộp ([20]=[16]-[17]-[18]",
        value3: "[20]",
        value4: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: 0,
      value10: "",
      value11: 0,
      value12: "",
      value13: 0,
      value14: 0,
      value15: 0,
      value16: 0,
      value17: 0,
      value18: 0,
      value19: 0,
      value20: 0,
      value21: 0,
      value22: "",
      value23: 0,
      value24: 0,
      value25: 0,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <Typography variant="h4" textTransform="uppercase">
          A. Xác định ưu đãi thuế thu nhập doanh nghiệp của người nộp thuế tại trụ sở chính, đơn vị
          phụ thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                TT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Tên NNT, đơn vị phụ thuộc, địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Mã số thuế NNT, đơn vị phụ thuôc, mã địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Cơ quan thuế quản lý NNT, đơn vị phụ thuộc, địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Điều kiện được hưởng ưu đãi thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="3">
                Thông tin dự án đầu tư
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="4">
                Xác định thời gian ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="4">
                Kết quả kinh doanh của hoạt động được hưỡng ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="5">
                Xác định số thuế được ưu đãi thuế suất
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="3">
                Xác định số thuế được miễn, giảm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Tổng số thuế được ưu đãi
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Cơ quan Thuế quản lý
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Tên dự án đầu tư
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Mã dự án đầu tư (nếu có)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Lĩnh vực hoạt động
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Ưu đãi thuế suất
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Miễn giảm thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Doanh thu tính thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Chi phí tính thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Thu nhập miễn thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Chuyển lỗ và bù trừ lãi, lỗ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                TNTT được hưởng ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Thuế suất ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế TNDN phải nộp theo thuế suất phổ thông
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế TNDN tính theo thuế suất ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế chênh lệch do áp dụng thuế suất ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Tỷ lệ giảm thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế được miễn
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số thuế được giảm
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số năm</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Từ năm</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số năm</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Từ năm</Th>
            </tr>

            <tr style={{ background: "#eaeae9" }}>
              <Th className="toggle-button" style={{ textAlign: "center" }}>
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
                (1)
              </Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)</Th>
              <Th style={{ textAlign: "center" }}>(14)</Th>
              <Th style={{ textAlign: "center" }}>(15)</Th>
              <Th style={{ textAlign: "center" }}>(16)</Th>
              <Th style={{ textAlign: "center" }}>(17)</Th>
              <Th style={{ textAlign: "center" }}>(18)</Th>
              <Th style={{ textAlign: "center" }}>(19)</Th>
              <Th style={{ textAlign: "center" }}>(20)</Th>
              <Th style={{ textAlign: "center" }}>(21)</Th>
              <Th style={{ textAlign: "center" }}>(22)</Th>
              <Th style={{ textAlign: "center" }}>(23)</Th>
              <Th style={{ textAlign: "center" }}>(24)</Th>
              <Th style={{ textAlign: "center" }}>(25=21+23+24)</Th>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3", minWidth: "90px" }}>
                {item.value4}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value5", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value8", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    value={item.value14}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value16"
                    value={item.value16}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value17"
                    value={item.value17}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value18"
                    value={item.value18}
                    onChange={handleChange}
                    rowType="muc1"
                    type="number"
                  />
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value19}
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value20}
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value21}
                </Td>
                <Td style={{ textAlign: "center", }}>
                <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value22", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value23}
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value24}
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>
                {item.value25}
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="4"
              >
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h4" textTransform="uppercase">
          B. Xác định số thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế  TNDN của đơn vị phụ thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
        <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
              Tên chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (3)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (4)
              </Th>
            </tr>
          </thead>
          <tbody>
          {data.muc2.map((item, index) => (
              <tr key={index} style={{}}>
                <Td style={{ textAlign: "center", background: item.bg ? "#ddeff3" : "transparent" }}>
                  {index + 1}
                </Td>
                <Td style={{ textAlign: "left", background: item.bg ? "#ddeff3" : "transparent" }}>
                {item.value2}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold",background: item.bg ? "#ddeff3" : "transparent"}}>
                {item.value3}
                </Td>
                <Td style={{ textAlign: "right",background: "#ddeff3"}}>
                {item.value4}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
    </Box>
  );
}

export default memo(Table6);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: "100%",
        minWidth: "70px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
